// The frozen instant of the nearest McRoot, in epoch milliseconds. Components read time only here (never the clock),
// so a capture frame and a gallery cell render the same text on every run.

import { useMc } from "./McRoot";

export function useNow(): number {
  return useMc().now;
}
